<template>
  <div class="d-flex flex-row align-items-center justify-content-between wd-100p-force" v-if="show">
    <div class="d-flex flex-row align-items-center justify-content-start">
      <button class="btn btn-sm btn-outline-secondary mg-rem-r-1" :disabled="disabled || pageComputed <= 1" @click="goFirst">« First</button>
      <button class="btn btn-sm btn-outline-secondary mg-rem-r-2" :disabled="disabled || pageComputed <= 1" @click="goPrev">‹ Prev</button>

      <template v-for="(p, idx) in visiblePages" :key="idx">
        <button v-if="typeof p === 'number'"
                class="btn btn-sm mg-rem-r-1"
                :class="p === pageComputed ? 'btn-primary' : 'btn-outline-primary'"
                :disabled="disabled"
                @click="emitPage(p)">
          {{ p }}
        </button>
        <span v-else class="mg-rem-r-1">…</span>
      </template>

      <button class="btn btn-sm btn-outline-secondary mg-rem-l-2 mg-rem-r-1" :disabled="disabled || pageComputed >= maxPage" @click="goNext">Next ›</button>
      <button class="btn btn-sm btn-outline-secondary" :disabled="disabled || pageComputed >= maxPage" @click="goLast">Last »</button>
    </div>

    <div class="d-flex flex-row align-items-center">
      <span class="tx-12 mg-rem-r-2">{{ from }}–{{ to }} из {{ count }}</span>
      <select class="form-control form-control-sm wd-100-force" :disabled="disabled" :value="pageSize" @change="onPageSize($event)">
        <option v-for="s in pageSizesComputed" :key="s" :value="s">{{ s }}/стр</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    page: { type: Number, required: true },
    pageSize: { type: Number, required: true },
    count: { type: Number, default: 0 },
    pageSizes: { type: Array, default: () => [25, 50, 100, 200] },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:page', 'update:pageSize'],
  computed: {
    show() { return this.count > 0; },
    pageComputed() { return this.page > 0 ? this.page : 1; },
    maxPage() { return Math.max(1, Math.ceil((this.count || 0) / (this.pageSize || 1))); },
    from() {
      if (!this.count) { return 0; }
      return (this.pageComputed - 1) * this.pageSize + 1;
    },
    to() {
      if (!this.count) { return 0; }
      return Math.min(this.count, this.pageComputed * this.pageSize);
    },
    pageSizesComputed() {
      const base = Array.isArray(this.pageSizes) && this.pageSizes.length ? this.pageSizes : [25, 50, 100, 200];
      return base;
    },
    visiblePages() {
      const p = this.pageComputed;
      const max = this.maxPage;
      const pages = [];
      const add = (v) => pages.push(v);

      const start = Math.max(1, p - 2);
      const end = Math.min(max, p + 2);

      if (start > 1) { add(1); }
      if (start > 2) { add('...'); }

      for (let i = start; i <= end; i++) { add(i); }

      if (end < max - 1) { add('...'); }
      if (end < max) { add(max); }

      return pages;
    }
  },
  methods: {
    emitPage(p) {
      if (p < 1) p = 1;
      if (p > this.maxPage) p = this.maxPage;
      this.$emit('update:page', p);
    },
    onPageSize(e) {
      const val = parseInt(e.target.value);
      if (!isNaN(val) && val > 0) {
        this.$emit('update:pageSize', val);
      }
    },
    goFirst() { this.emitPage(1); },
    goPrev() { this.emitPage(this.pageComputed - 1); },
    goNext() { this.emitPage(this.pageComputed + 1); },
    goLast() { this.emitPage(this.maxPage); },
  }
}
</script>


